
import React from 'react';

export const Debug: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  if (process.env.NODE_ENV !== 'development') return null;
  return (
    <div style={{
      background: '#222',
      color: '#fff',
      padding: 16,
      fontSize: 14,
      fontFamily: 'monospace',
      borderRadius: 4,
      margin: 8,
      zIndex: 9999,
    }}>
      {children || 'Debug info'}
    </div>
  );
};